import { AppThemeProvider } from "./shared/contexts";
import { createMuiTheme } from "@material-ui/core/styles";
import { createRoot } from 'react-dom/client';
import { grey } from "@material-ui/core/colors";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import React, { StrictMode } from "react";
import store from "./store";

import "./assets/css/dsgov-icons.css";
import "./assets/css/fontAwesome.css";
import "meu-inss-ds/dist/assets/styles.css"

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#1351b4",
      light: "#5e92f3",
      dark: "#003c8f",
      contrastText: "#FFF",
    },
    corTexto: "#4d7aa1",
    corTitulo: "#4d7aa1",
    secondary: {
      main: grey[700],
      light: grey[600],
      dark: grey[800],
      contrastText: "#777",
    },
  },
  typography: {
    fontFamily: [
      "Rawline",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        background: "transparent",
        border: "1px solid transparent",
        borderRadius: "20px",
        color: "#1351b4",
        height: "48px",
        lineHeight: "40px",
        fontSize: "14px",
        fontWeight: "600",
        margin: "auto",
        width: "auto",
        padding: "0px",
        textTransform: "none",
        whiteSpace: "nowrap",
      },
      text: {
        padding: "0px",
      },
      label: {
        marginLeft: "40px",
        marginRight: "40px",
      },
      textPrimary: {
        textDecoration: "underline",
        "&:active": {
          boxShadow: "none",
          background: "#071d41 !important",
          color: "#FFF !important",
        },
        "&:focus": {
          boxShadow: "none",
          background:
            "#fff linear-gradient(rgba(242, 227, 23, 0.3), rgba(242, 227, 23, 0.3))",
        },
        "&:hover": {
          boxShadow: "none",
          background: "#dbe8fb !important",
        },
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none",
          background: "#071d41 !important",
          color: "#FFF !important",
        },
        "&:focus": {
          boxShadow: "none",
          background:
            "#fff linear-gradient(rgba(242, 227, 23, 0.3), rgba(242, 227, 23, 0.3))",
        },
        "&:hover": {
          boxShadow: "none",
          background: "#dbe8fb !important",
        },
        "&:disabled": {
          cursor: "not-allowed",
          opacity: "0.5",
          pointerEvents: "all",
          background: "#1351b4",
          color: "#fff",
          "&:hover": {
            background: "#1351b4 !important",
            color: "#fff",
          },
        },
      },
      containedPrimary: {
        background: "#1351b4",
        color: "#fff",
        "&:active": {
          color: "#fff",
        },
        "&:focus": {
          color: "#1351b4",
        },
        "&:hover": {
          color: "#1351b4",
        },
      },
      containedSecondary: {
        backgroundColor: "transparent",
        borderColor: "#1351b4",
        color: "#1351b4",
      },
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  //<MuiThemeProvider theme={theme}>
  <AppThemeProvider>
    <Provider store={store}>
      <Router>
          <App />
      </Router>
    </Provider>
    {/* //</MuiThemeProvider>, */}
  </AppThemeProvider>
);

